// React
import React from "react";
// React

// Utils
import { Route, Routes } from "react-router-dom";
// Utils

// Models
import { I_QuizMakerQuestions } from "../Models/interfaces";
// Models

// Pages
import QuestionCreatorQuestionViewer from "../Pages/QuestionCreatorQuestionViewer/QuestionCreatorQuestionViewer";
import QuizMaker from "../Pages/QuizMaker/QuizMaker";
import Home from "../Pages/Home/Home";
import QuizCreatorAnswerShower from "../Pages/QuizMaker/QuizCreatorAnswerShower/QuizCreatorAnswerShower";
import Shop from "../Pages/Shop/Shop";
import OTP from "../Components/OTP/OTP";
import Profile from "../Pages/Profile/Profile";
import Edit from "../Pages/Profile/Edit/Edit";
import CustomRedirection from "../Components/CustomRedirector/CustomRedirector";
import ContactUs from "../Pages/Profile/ContactUs/ContactUs";
import Messages from "../Pages/Profile/Messages/Messages";
import Files from "../Pages/Profile/Files/Files";
import Tickets from "../Pages/Profile/Tickets/Tickets";
import TicketManager from "../Pages/Profile/Tickets/TicketManager/TicketManager";
import PdfMaker from "../Pages/Profile/PdfMaker/PdfMaker";
import AdsContainer from "../Pages/AdsContainer/AdsContainer";
import Ads2 from "../Pages/Ads2/Ads2";
import Lesson from "../Pages/Lesson/Lesson";
import Teacher from "../Pages/Teacher/Teacher";
import TeachItemVideoShower from "../Pages/TeachItemVideoShower/TeachItemVideoShower";
import TestTeachItemVideoShower from "../Pages/TestTeachItemVideoShower/TestTeachItemVideoShower";
import VideoTag from "../Pages/VideoTag/VideoTag";
import DeviceManager from "../Pages/DeviceManager/DeviceManager";
import Subject from "../Pages/Subject/Subject";
import QuestionsBank from "../Pages/QuestionsBank/QuestionsBank";
import CategoryLessons from "../Pages/QuestionsBank/CategoryLessons/CategoryLessons";
import ExamPdfs from "../Pages/QuestionsBank/ExamPdfs/ExamPdfs";
// Pages

type RouterProps = {
  userToken: string;
  setUserToken: React.Dispatch<React.SetStateAction<string>>;

  userQuestions: I_QuizMakerQuestions[];
  setUserQuestions: React.Dispatch<
    React.SetStateAction<I_QuizMakerQuestions[]>
  >;

  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Router: React.FunctionComponent<RouterProps> = ({
  userToken,
  setUserQuestions,
  userQuestions,
  setIsNeedFullScreen,
  setUserToken,
}) => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={userToken !== "init" && <Home />} />
      {/* Home */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Quiz Page */}
      <Route path="/quiz-maker" element={<QuizMaker />} />
      <Route
        path="/quiz-maker/quiz-questions"
        element={
          <QuestionCreatorQuestionViewer
            questions={userQuestions}
            setIsNeedFullScreenNeed={setIsNeedFullScreen}
          />
        }
      />
      <Route
        path="/quiz-maker/show-answers"
        element={
          <QuizCreatorAnswerShower
            setIsNeedFullScreenNeed={setIsNeedFullScreen}
          />
        }
      />
      {/* Quiz Page */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Shop */}
      <Route path="/shop" element={<Shop />} />
      {/* Shop */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* OTP */}
      <Route
        path="/otp"
        element={
          <OTP
            setUserToken={setUserToken}
            setIsNeedFullScreen={setIsNeedFullScreen}
          />
        }
      />
      {/* OTP */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Profile */}
      <Route path="/profile" element={<Profile />}></Route>
      <Route path="/profile/edit" element={<Edit />} />
      <Route
        path="/profile/eula"
        element={
          <CustomRedirection routeToNavigate="http://amoozeshmelli.com/terms/" />
        }
      />
      <Route path="/profile/contact-us" element={<ContactUs />} />
      <Route path="/profile/messages" element={<Messages />} />
      <Route
        path="/profile/files"
        element={<Files setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/profile/tickets"
        element={<Tickets setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/profile/tickets/add"
        element={<TicketManager setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/profile/tickets/:ticketId"
        element={<TicketManager setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/profile/pdf-maker"
        element={
          <PdfMaker
            questions={userQuestions}
            setIsNeedFullScreen={setIsNeedFullScreen}
          />
        }
      />
      <Route
        path="/profile/device-manager"
        element={<DeviceManager setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      {/* Profile */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Ads */}
      <Route
        path="/ads"
        element={<AdsContainer setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route path="/ads2" element={<Ads2 />} />{" "}
      {/* <Route
    path="/ads3"
    element={<AdsContainer setIsNeedFullScreen={setIsNeedFullScreen} />}
  /> */}
      {/* Ads */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* UserLesson */}
      <Route
        path="/lesson/:lessonId"
        element={<Lesson setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      {/* UserLesson */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Subject */}
      <Route path="/subject/:teacherId/:subjectId" element={<Subject />} />
      {/* Subject */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* Teacher */}
      <Route path="/teacher/:teacherId" element={<Teacher />} />
      {/* Teacher */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* VideoShower */}
      <Route
        path="/video-player-teach/:teachItemId"
        element={
          <TeachItemVideoShower
            setIsNeedFullScreen={setIsNeedFullScreen}
            setUserQuestions={setUserQuestions}
          />
        }
      />
      <Route
        path="/test__test/__video-player-teach__/:teachItemId"
        element={
          <TestTeachItemVideoShower
            setIsNeedFullScreen={setIsNeedFullScreen}
            setUserQuestions={setUserQuestions}
          />
        }
      />
      <Route
        path="/test__test/__video-tag__/:teachItemId"
        element={<VideoTag />}
      />
      {/* VideoShower */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* TicketCenter */}
      <Route
        path="/ticketing"
        element={<Tickets setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/ticketing/tickets"
        element={<Tickets setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/ticketing/tickets/add"
        element={<TicketManager setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      <Route
        path="/ticketing/tickets/:ticketId"
        element={<TicketManager setIsNeedFullScreen={setIsNeedFullScreen} />}
      />
      {/* TicketCenter */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* QuestionBank Section */}
      <Route
        path="/question-bank"
        element={<QuestionsBank />}
      />
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* QuestionBank Lessons Category */}
      <Route
        path="/question-bank/:lessonId/categories"
        element={<CategoryLessons />}
      />
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* QuestionBank Pdfs */}
      <Route
        path="/question-bank/:lessonId/categories/:categoryId/pdfs"
        element={<ExamPdfs />}
      />
    </Routes>
  );
};

export default Router;
